<template>
  <el-drawer
    ref="driverDetail"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="60%"
    withHeader="false"
    @open="openDetail"
  >
    <div slot="title" style="display: flex; align-items: center">
      <div>车辆详情-{{ info.plateNumber }}</div>
      <div class="tips_box">
        注意：该模块信息用于上传至交通部门监管信息平台，请保持信息完整与正确性！
      </div>
    </div>
    <div style="padding: 0 0 10px 20px; color: #606266; font-size: 14px">
      <span>信息完整度：</span>
      <span>{{ info.completeRate ? info.completeRate + '%' : '' }}</span>
    </div>
    <div class="top_box">
      <div class="dian"></div>
      <div style="margin-right: 20px">
        {{ info.auditState === 1 ? '待审核' : info.auditState === 2 ? '审核通过' : '拒绝' }}
      </div>
      <div v-if="info.auditState === 1">
        <el-button
          size="small"
          type="primary"
          @click="auditClick(2)"
          v-has-permi="['vehicle_audit']"
        >
          通过
        </el-button>
        <el-button
          size="small"
          type="danger"
          @click="auditClick(3)"
          v-has-permi="['vehicle_audit']"
        >
          不通过
        </el-button>
      </div>
    </div>
    <el-tabs v-model="active" type="card" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="first">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-descriptions :column="1" style="margin-left: 40px">
              <el-descriptions-item label="业务类型" prop="merchantName">
                {{ info.bizTypeStr }}
              </el-descriptions-item>
              <el-descriptions-item label="所属供应商" prop="merchantName">
                {{ info.merchantName }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆注册城市">{{ info.areaName }}</el-descriptions-item>
              <el-descriptions-item label="车辆车架号">{{ info.vin }}</el-descriptions-item>
              <el-descriptions-item label="车牌燃料类型">{{ info.fuelType }}</el-descriptions-item>
              <el-descriptions-item label="车牌颜色">
                {{ info.plateNumberColor }}
              </el-descriptions-item>
              <el-descriptions-item label="发动机排量">
                {{ info.vehicleEmissions }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆检修状态">
                {{ info.carMaintenanceStatus }}
              </el-descriptions-item>
              <el-descriptions-item label="卫星定位设备安装日期">
                {{ info.gpsInstallDate }}
              </el-descriptions-item>
              <el-descriptions-item label="卫星定位装置品牌">
                {{ info.gpsBrand }}
              </el-descriptions-item>
              <el-descriptions-item label="发票打印设备序列号">
                {{ info.printDeviceNo }}
              </el-descriptions-item>
              <el-descriptions-item label="行驶证发证日期">
                {{ info.drivingLicenseStart }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆图片">
                <el-image
                  v-for="(item, index) in info.images"
                  :preview-src-list="previewList"
                  :key="index"
                  style="width: 100px; height: 100px"
                  :src="item"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image>
              </el-descriptions-item>
              <el-descriptions-item label="行驶证">
                <div>
                  <span
                    :style="
                      drivingLicenseEnd === 'expiringSoon'
                        ? 'color: #FF881B'
                        : drivingLicenseEnd === 'expire'
                        ? 'color: #FA5151'
                        : ''
                    "
                  >
                    {{
                      drivingLicenseEnd === 'expiringSoon'
                        ? '证照即将过期，请及时办理更新'
                        : drivingLicenseEnd === 'expire'
                        ? '证照已过期，请及时办理更新'
                        : ''
                    }}
                  </span>
                  <div class="flex">
                    <div class="img_box" v-for="item in drivingLicenselist" :key="item">
                      <el-image
                        :src="item.url"
                        :preview-src-list="previewList"
                        style="width: 120px; height: 100px; margin-right: 20px"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <span>{{ item.text }}</span>
                    </div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="车辆登记证">
                <div class="img_box" v-for="item in vehicleImgList" :key="item">
                  <el-image
                    :src="item.url"
                    :preview-src-list="previewList"
                    style="width: 120px; height: 100px; margin-right: 20px"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <span>{{ item.text }}</span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="GPS设备安装回执单">
                <div class="img_box">
                  <el-image
                    style="width: 120px; height: 100px; margin-right: 20px"
                    :src="info.gpsReceiptImg"
                    :preview-src-list="previewList"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <span>GPS设备安装回执单</span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="车辆技术等级评定" v-if="info.technicalRating">
                <div class="flex flex-col flex-center">
                  <div class="flex">
                    <!-- <el-image
                      v-for="(item, index) in info.technicalRating.split(',')"
                      :key="index"
                      style="width: 120px; height: 100px"
                      :class="info.technicalRating.split(',').length > 1 ? 'margin-right-20' : ''"
                      :src="item"
                      :preview-src-list="previewList"
                    >
                      <template slot="error">
                        <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                      </template>
                    </el-image> -->
                    <div :key="index" v-for="(item, index) in info.technicalRating.split(',')">
                      <el-image
                        v-if="isImage(item)"
                        style="width: 120px; height: 100px"
                        :class="info.technicalRating.split(',').length > 1 ? 'margin-right-20' : ''"
                        :src="item"
                        :preview-src-list="[item]"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <div v-else class="font-12 color-999 box" @click="handleDownload(item)">
                        <i class="el-icon-document font-18"></i>
                        <span class="line-1 font-16">{{ getFileName(item) }}</span>
                      </div>
                    </div>
                  </div>
                  <span class="font-12 margin-top-10">车辆技术等级评定</span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="技术等级评定日期">
                {{ info.technicalRatingOn }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆等级评定有效期止">
                <span
                  :style="
                    technicalRatingOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : technicalRatingOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{ info.technicalRatingOff }}
                </span>
                <span
                  style="margin-left: 10px"
                  :style="
                    technicalRatingOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : technicalRatingOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{
                    technicalRatingOff === 'expiringSoon'
                      ? '即将过期'
                      : technicalRatingOff === 'expire'
                      ? '已过期'
                      : ''
                  }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="车辆二级维护记录卡" v-if="info.maintenance">
                <div class="flex flex-col flex-center">
                  <div class="flex">
                    <!-- <el-image
                      v-for="(item, index) in info.maintenance.split(',')"
                      :key="index"
                      style="width: 120px; height: 100px"
                      :class="info.maintenance.split(',').length > 1 ? 'margin-right-20' : ''"
                      :src="item"
                      :preview-src-list="previewList"
                    >
                      <template slot="error">
                        <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                      </template>
                    </el-image> -->
                    <div v-for="(item, index) in info.maintenance.split(',')" :key="index">
                      <el-image
                        v-if="isImage(item)"
                        style="width: 120px; height: 100px"
                        :class="info.maintenance.split(',').length > 1 ? 'margin-right-20' : ''"
                        :src="item"
                        :preview-src-list="[item]"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <div v-else class="font-12 color-999 box" @click="handleDownload(item)">
                        <i class="el-icon-document font-18"></i>
                        <span class="line-1 font-16">{{ getFileName(item) }}</span>
                      </div>
                    </div>
                  </div>
                  <span class="font-12 margin-top-10">车辆二级维护记录卡</span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="车辆二级维护日期">
                {{ info.maintenanceOn }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆二级维护有效期止">
                <span
                  :style="
                    maintenanceOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : maintenanceOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{ info.maintenanceOff }}
                </span>
                <span
                  style="margin-left: 10px"
                  :style="
                    maintenanceOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : maintenanceOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{
                    maintenanceOff === 'expiringSoon'
                      ? '即将过期'
                      : maintenanceOff === 'expire'
                      ? '已过期'
                      : ''
                  }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="12">
            <el-descriptions :column="1">
              <el-descriptions-item label="核定载客位">{{ info.seats }}</el-descriptions-item>
              <el-descriptions-item label="车型信息">
                {{ info.brandName }}-{{ info.seriesName }}-{{ info.colorName }}
              </el-descriptions-item>
              <el-descriptions-item label="发动机号">{{ info.engineNo }}</el-descriptions-item>
              <el-descriptions-item label="车辆注册日期">
                {{ info.registerDate }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆所有人">{{ info.ownerName }}</el-descriptions-item>
              <el-descriptions-item label="车辆类型">{{ info.vehicleType }}</el-descriptions-item>
              <el-descriptions-item label="车辆年度审验状态">
                {{ info.annualCheckStatus }}
              </el-descriptions-item>
              <el-descriptions-item label="车辆下次年检时间">
                <span
                  :style="
                    nextAnnualCheck === 'expiringSoon'
                      ? 'color: #FF881B'
                      : nextAnnualCheck === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{ info.nextAnnualCheck }}
                </span>
                <span
                  style="margin-left: 10px"
                  :style="
                    nextAnnualCheck === 'expiringSoon'
                      ? 'color: #FF881B'
                      : nextAnnualCheck === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{
                    nextAnnualCheck === 'expiringSoon'
                      ? '即将过期'
                      : nextAnnualCheck === 'expire'
                      ? '已过期'
                      : ''
                  }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="卫星定位装置型号">
                {{ info.gpsType }}
              </el-descriptions-item>
              <el-descriptions-item label="卫星定位装置IMEI号">
                {{ info.gpsImei }}
              </el-descriptions-item>
              <el-descriptions-item label="行驶证有效期止">
                <span
                  :style="
                    drivingLicenseEnd === 'expiringSoon'
                      ? 'color: #FF881B'
                      : drivingLicenseEnd === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{ info.drivingLicenseEnd }}
                </span>
                <span
                  style="margin-left: 10px"
                  :style="
                    drivingLicenseEnd === 'expiringSoon'
                      ? 'color: #FF881B'
                      : drivingLicenseEnd === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                >
                  {{
                    drivingLicenseEnd === 'expiringSoon'
                      ? '即将过期'
                      : drivingLicenseEnd === 'expire'
                      ? '已过期'
                      : ''
                  }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="运营登记" name="second">
        <el-descriptions :column="1" style="margin-left: 40px">
          <el-descriptions-item label="运营类型">
            {{ info.operationType === 1 ? '道路运输' : info.operationType === 2 ? '网络预约' : '' }}
          </el-descriptions-item>
          <el-descriptions-item label="车辆运输证字号">{{ info.transportNo }}</el-descriptions-item>
          <el-descriptions-item label="报备日期">{{ info.reportDate }}</el-descriptions-item>
          <el-descriptions-item label="车辆运输证发证机构">{{ info.tcb }}</el-descriptions-item>
          <el-descriptions-item label="车辆经营区域">{{ info.operateArea }}</el-descriptions-item>
          <el-descriptions-item label="车辆初次登记日期">
            {{ info.firstRegisterdate }}
          </el-descriptions-item>
          <el-descriptions-item label="车辆运输证有效期起">
            {{ info.validityBegindate }}
          </el-descriptions-item>
          <el-descriptions-item label="车辆运输证有效期止">
            <span
              :style="
                validityEnddate === 'expiringSoon'
                  ? 'color: #FF881B'
                  : validityEnddate === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{ info.validityEnddate }}
            </span>

            <span
              style="margin-left: 10px"
              :style="
                validityEnddate === 'expiringSoon'
                  ? 'color: #FF881B'
                  : validityEnddate === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{
                validityEnddate === 'expiringSoon'
                  ? '即将过期'
                  : validityEnddate === 'expire'
                  ? '已过期'
                  : ''
              }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="车辆运输证下次审验时间">
            <span
              :style="
                transportCertificateCheck === 'expiringSoon'
                  ? 'color: #FF881B'
                  : transportCertificateCheck === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{ info.transportCertificateCheck }}
            </span>
            <span
              style="margin-left: 10px"
              :style="
                transportCertificateCheck === 'expiringSoon'
                  ? 'color: #FF881B'
                  : transportCertificateCheck === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{
                transportCertificateCheck === 'expiringSoon'
                  ? '即将过期'
                  : transportCertificateCheck === 'expire'
                  ? '已过期'
                  : ''
              }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="车辆运输证">
            <div>
              <span
                :style="
                  validityEnddate === 'expiringSoon'
                    ? 'color: #FF881B'
                    : validityEnddate === 'expire'
                    ? 'color: #FA5151'
                    : ''
                "
              >
                {{
                  validityEnddate === 'expiringSoon'
                    ? '证照即将过期，请及时办理更新'
                    : validityEnddate === 'expire'
                    ? '证照已过期，请及时办理更新'
                    : ''
                }}
              </span>
              <div class="flex">
                <div class="img_box" v-for="item in transportgList" :key="item">
                  <el-image
                    :src="item.url"
                    :preview-src-list="previewList"
                    style="width: 120px; height: 100px; margin-right: 20px"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <span>{{ item.text }}</span>
                </div>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="车辆购置发票">
            <el-image
              style="width: 120px; height: 100px; margin-right: 20px"
              :src="info.carInvoice"
              :preview-src-list="previewList"
            >
              <template slot="error">
                <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
              </template>
            </el-image>
          </el-descriptions-item>
          <el-descriptions-item label="加盟合作协议" v-if="info.franchiseAgreement">
            <div class="flex flex-col flex-center">
              <div class="flex">
                <!-- <el-image
                  v-for="(item, index) in info.franchiseAgreement.split(',')"
                  :key="index"
                  style="width: 120px; height: 100px"
                  :class="info.franchiseAgreement.split(',').length > 1 ? 'margin-right-20' : ''"
                  :src="item"
                  :preview-src-list="previewList"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image> -->
                <div v-for="(item, index) in info.franchiseAgreement.split(',')" :key="index">
                  <el-image
                    v-if="isImage(item)"
                    style="width: 120px; height: 100px"
                    :class="info.franchiseAgreement.split(',').length > 1 ? 'margin-right-20' : ''"
                    :src="item"
                    :preview-src-list="[item]"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <div v-else class="font-12 color-999 box" @click="handleDownload(item)">
                    <i class="el-icon-document font-18"></i>
                    <span class="line-1 font-16">{{ getFileName(item) }}</span>
                  </div>
                </div>
              </div>
              <span class="font-12 margin-top-10">加盟合作协议</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="合作协议有效期起">
            {{ info.franchiseAgreementOn }}
          </el-descriptions-item>
          <el-descriptions-item label="合作协议有效期止">
            <span
              :style="
                franchiseAgreementOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : franchiseAgreementOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{ info.franchiseAgreementOff }}
            </span>
            <span
              style="margin-left: 10px"
              :style="
                franchiseAgreementOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : franchiseAgreementOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
            >
              {{
                franchiseAgreementOff === 'expiringSoon'
                  ? '即将过期'
                  : franchiseAgreementOff === 'expire'
                  ? '已过期'
                  : ''
              }}
            </span>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="金融信息" name="third">
        <el-descriptions :column="1" style="margin-left: 40px">
          <el-descriptions-item label="贷款机构">
            {{ info.carBankingReqVo.organName }}
          </el-descriptions-item>
          <el-descriptions-item label="贷款主体">
            {{ info.carBankingReqVo.loanSubject }}
          </el-descriptions-item>
          <el-descriptions-item label="担保方">
            {{ info.carBankingReqVo.bonded }}
          </el-descriptions-item>
          <el-descriptions-item label="每期还款金额">
            {{ info.carBankingReqVo.refundPlan }}
          </el-descriptions-item>
          <el-descriptions-item label="合计还款金额">
            {{ info.carBankingReqVo.refundTotal }}
          </el-descriptions-item>
          <el-descriptions-item label="还款利息">
            {{ info.carBankingReqVo.refundInterest }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="保险信息" name="fourth">
        <div class="add_btn">
          <el-button
            type="primary"
            @click="addClick()"
            size="mini"
            style="margin-right: 40px"
            v-has-permi="['vehicle_edit']"
          >
            添加保险
          </el-button>
        </div>
        <el-table :data="info.carInsuranceRepVo" border size="mini">
          <el-table-column prop="insuranceTypeStr" label="保险类别" align="center" width="80" />
          <el-table-column prop="policyNo" label="保险号" align="center" />
          <el-table-column prop="insuranceCompany" label="保险公司" align="center" />
          <el-table-column prop="premium" label="保费" align="center" />
          <el-table-column prop="sumAssured" label="保额" align="center" />
          <el-table-column prop="insurancePeriodBegin" label="保险生效时间" align="center" />
          <el-table-column prop="insurancePeriodEnd" label="保险到期时间" align="center" />
          <el-table-column prop="expirationDay" label="保险剩余天数" align="center">
            <template slot-scope="{ row }">
              <span :style="row.expirationDay < 0 && 'color: #FA5151'">
                {{ row.expirationDay }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.img" class="flex-center flex-wrap">
                <template v-for="(item, index) in scope.row.img.split(',')">
                  <a
                    class="file_btn"
                    :key="item"
                    target="_blank"
                    v-if="!isPdf(item)"
                    @click="handleLookImg(item)"
                  >
                    查看保单{{ index + 1 }}
                  </a>
                  <a v-else :key="item" :href="item" target="_blank" class="file_btn">
                    查看保单{{ index + 1 }}
                  </a>
                </template>

                <!-- <a
                  v-for="(item, index) in scope.row.img.split(',')"
                  :key="item"
                  :href="item"
                  target="_blank"
                  class="file_btn"
                  >查看保单{{ index + 1 }}</a
                > -->
              </div>
              <el-button
                v-if="info.auditState !== 2"
                type="text"
                @click="editClick(scope.row)"
                size="mini"
                v-has-permi="['insurance_edit']"
              >
                编辑
              </el-button>
              <el-button
                v-if="info.auditState !== 2"
                type="text"
                @click="deleteClick(scope.row)"
                size="mini"
                v-has-permi="['vehicle_insurance_delete']"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="操作日志" name="fifth">
        <div class="padding-x-10">
          <operation-log :list="logList" :maxHeight="logTableHeight" />
        </div>
      </el-tab-pane>
    </el-tabs>
    <carInsurance-add
      v-if="visible"
      :visible="visible"
      :carInsuranceForm="carInsuranceForm"
      @saveCarInsurance="saveCarInsurance"
      @closeClick="closeInsurance"
    />
    <el-image
      v-if="dialogImageUrl"
      :src="dialogImageUrl"
      fit="contain"
      style="width: 60px; height: 60px"
      :preview-src-list="[dialogImageUrl]"
      ref="reviewImage"
    />
  </el-drawer>
</template>

<script>
  import {
    getCarInfo,
    driverAudit,
    insureSaveOrUpdate,
    insureDelete
  } from '@/api/vehicle/vehicle-manage'
  import { getLog } from '@/api/common'
  import { to } from '@/util/util'
  import CarInsuranceAdd from './carInsurance-add'
  import OperationLog from '@/components/log-info/list'

  export default {
    components: {
      CarInsuranceAdd,
      OperationLog
    },
    props: {
      activeName: {
        type: String,
        default: 'first'
      }
    },
    data() {
      return {
        logTableHeight: window.innerHeight - 190,
        info: {
          carBankingReqVo: {},
          images: [],
          registerDate: '',
          technicalRating: '',
          maintenance: '',
          franchiseAgreement: ''
        },
        drawer: false,
        visible: false,
        insuranceTypeList: [
          { label: '交强险', key: 1 },
          { label: '商业险', key: 2 },
          { label: '承运人责任险', key: 3 }
        ],
        carInsuranceForm: {},
        img: '',
        carInsuranceImg: [],
        drivingLicenselist: [],
        vehicleImgList: [],
        transportgList: [],
        previewList: [],
        logList: [],
        active: 'first',

        drivingLicenseEnd: '',
        nextAnnualCheck: '',
        validityEnddate: '',
        transportCertificateCheck: '',
        technicalRatingOff: '',
        maintenanceOff: '',
        franchiseAgreementOff: '',
        dialogImageUrl: ''
      }
    },
    mounted() {
      this.active = this.activeName
    },
    methods: {
      // 数据初始化
      init(id) {
        this.logList = []
        this.getCarInfoDetails(id)
        this.getLogData(id)
      },
      /* 获取车辆详情 */
      async getCarInfoDetails(params) {
        this.$loading()
        const [err, res] = await to(getCarInfo(params))
        this.$loading().close()
        if (err) {
          throw err
        }
        const { code, data } = res
        if (code === 0) {
          if (data.images) {
            this.previewList.push(data.images)
          }
          if (data.img) {
            this.carInsuranceImg.push(data.img)
            this.previewList.push(data.img)
          }
          if (data.drivingLicenseImg) {
            const drivingLicense = data.drivingLicenseImg.split(',')
            this.previewList.push(...drivingLicense)
            this.drivingLicenselist = [
              { url: drivingLicense[0], text: '行驶证（正页）' },
              { url: drivingLicense[1], text: '行驶证（副页）' }
            ]
          }
          if (data.vehicleImg) {
            const vehicleImg = data.vehicleImg.split(',')
            this.previewList.push(...vehicleImg)
            this.vehicleImgList = [
              { url: vehicleImg[0], text: '车辆登记证（页1）' },
              { url: vehicleImg[1], text: '车辆登记证（页2）' }
            ]
          }
          if (data.gpsReceiptImg) {
            this.previewList.push(data.gpsReceiptImg)
          }
          if (data.technicalRating) {
            const result = data.technicalRating.split(',')
            this.previewList.push(...result)
          }
          if (data.maintenance) {
            const result = data.maintenance.split(',')
            this.previewList.push(...result)
          }
          if (data.transportCertificateImg) {
            const transportCertificateImg = data.transportCertificateImg.split(',')
            this.previewList.push(...transportCertificateImg)
            this.transportgList = transportCertificateImg.map((item, index) => {
              return { url: item, text: `运输证（${index === 0 ? '正页' : '副页' + index}）` }
            })
          }
          if (data.carInvoice) {
            this.previewList.push(data.carInvoice)
          }
          if (data.franchiseAgreement) {
            const result = data.franchiseAgreement.split(',')
            this.previewList.push(...result)
          }
          if (!data.carBankingReqVo) {
            data.carBankingReqVo = {}
          }
          this.info = data
          this.drawer = true

          if (this.info.drivingLicenseEnd)
            this.computedDate(this.info.drivingLicenseEnd, 'drivingLicenseEnd')
          if (this.info.nextAnnualCheck)
            this.computedDate(this.info.nextAnnualCheck, 'nextAnnualCheck')
          if (this.info.validityEnddate)
            this.computedDate(this.info.validityEnddate, 'validityEnddate')
          if (this.info.transportCertificateCheck)
            this.computedDate(this.info.transportCertificateCheck, 'transportCertificateCheck')
          if (this.info.technicalRatingOff) {
            this.computedDate(this.info.technicalRatingOff, 'technicalRatingOff')
          }
          if (this.info.maintenanceOff) {
            this.computedDate(this.info.maintenanceOff, 'maintenanceOff')
          }
          if (this.info.franchiseAgreementOff) {
            this.computedDate(this.info.franchiseAgreementOff, 'franchiseAgreementOff')
          }
        }
      },
      async getLogData(id) {
        const { code, data } = await getLog({
          bizLinkId: id,
          type: 8
        })
        if (code === 0) {
          this.logList = data
        }
      },
      // 审核
      auditClick(auditState) {
        const params = {
          auditState,
          type: 1,
          id: this.info.id
        }
        if (auditState === 3) {
          this.$prompt('确定审核不通过吗？', '提示', {
            inputPlaceholder: '请输入不通过原因',
            inputErrorMessage: '请输入不通过原因',
            cancelButtonText: '稍后再看',
            confirmButtonText: '确定',
            inputType: 'textarea'
          })
            .then(({ value }) => {
              params.refuseReason = value
              this.handleDriverAudit(params)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        } else {
          this.handleDriverAudit(params)
        }
      },
      async handleDriverAudit(params) {
        this.$loading()
        const [err, res] = await to(driverAudit(params))
        this.$loading().close()
        if (err) {
          throw err
        }
        const { code } = res
        if (code === 0) {
          this.$message.success('操作成功')
          this.init(this.info.id)
        }
      },
      addClick() {
        this.carInsuranceForm = {}
        this.visible = true
      },
      getcarInsuranceImg(arr) {
        if (arr) {
          this.img = arr[0].url
        } else {
          this.img = ''
        }
      },
      saveCarInsurance(obj) {
        const params = {
          carId: this.info.id,
          ...obj
        }
        this.handleInsureSaveOrUpdate(params)
      },
      // 新增/编辑保险
      async handleInsureSaveOrUpdate(params) {
        this.$loading()
        const [err, res] = await to(insureSaveOrUpdate(params))
        this.$loading().close()
        if (err) {
          throw err
        }
        const { code } = res
        if (code === 0) {
          this.$message.success('操作成功')
          this.visible = false
          this.init(this.info.id)
        }
      },
      editClick(row) {
        console.log('row', row)
        this.carInsuranceForm = row
        this.visible = true
      },
      closeInsurance() {
        this.carInsuranceForm = {}
        this.visible = false
      },
      // 删除保险
      deleteClick(obj) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.handleInsureDelete(obj.id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      async handleInsureDelete(id) {
        this.$loading()
        const [err, res] = await to(insureDelete(id))
        this.$loading().close()
        if (err) {
          throw err
        }
        const { code } = res
        if (code === 0) {
          this.$message.success('操作成功')
          this.init(this.info.id)
        }
      },
      handleClose() {
        this.info = { carBankingReqVo: {}, images: [] }
        this.previewList = []
        this.carInsuranceForm = {}
        this.img = ''
        this.carInsuranceImg = []
        this.drivingLicenselist = []
        this.vehicleImgList = []
        this.transportgList = []
        this.drawer = false
        this.$emit('close')
      },

      // 计算日期
      computedDate(str, type) {
        const date = new Date(str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6))
        const m = new Date().getMonth() + 1 + ''
        const d = new Date().getDate() + ''
        const year = new Date().getFullYear()
        const month = m.length === 1 ? '0' + m : m
        const day = d.length === 1 ? '0' + d : d
        const nowDate = new Date(year + '-' + month + '-' + day)

        if (date - nowDate <= 8.64e7 * 30 && date - nowDate >= 0) {
          this[type] = 'expiringSoon'
        } else if (date - nowDate < 0) {
          this[type] = 'expire'
        } else {
          this[type] = ''
        }
      },
      isImage(file) {
        const reg = /\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif)/gi
        return reg.test(file)
      },
      // 下载  imgage图片blob类型下载
      handleDownload(file) {
        window.open(file)
      },
      getFileName(url) {
        if (!url) {
          return ''
        }
        const filePath = url.split('/')
        return filePath[filePath.length - 1].split('?')[0]
      },
      handleLookImg(url) {
        this.dialogImageUrl = url
        this.$nextTick(() => {
          this.$refs.reviewImage.clickHandler()
        })
      },
      // 判断是否为PDF文件
      isPdf(file) {
        const reg = /\.pdf/i
        return reg.test(file)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .file_btn {
    white-space: nowrap;
    color: #409eff;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
    cursor: pointer;
  }

  .img_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      font-size: 12px;
    }
  }

  .tips_box {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 20px;
  }

  .dian {
    height: 6px;
    width: 6px;
    border: 1px solid #909399;
    border-radius: 5px;
    background-color: #909399;
    margin-right: 5px;
  }

  .auditStateBox {
    font-size: 14px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .top_box {
    position: absolute;
    left: 70%;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    z-index: 99;
  }

  .el-tabs--card {
    height: calc(100vh - 110px);
    /* overflow-y: auto; */
  }

  .el-tab-pane {
    height: calc(100vh - 110px);
    overflow-y: auto;
  }

  .add_btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    width: 190px;
  }

  ::v-deep .el-drawer__body {
    overflow: hidden;
  }
  ::v-deep .el-tab-pane {
    height: calc(100vh - 160px);
    overflow-x: hidden;
  }
  .box {
    width: 120px;
    height: 100px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 20px;
  }
  .line-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; // 控制多行的行数
    -webkit-box-orient: vertical;
  }
</style>
